import { useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import Intro from "@/components/Intro";
import DiscountPopup from "@/components/DiscountPopup";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import StatsStrip from "@/components/StatsStrip";
import Shop from "@/components/Shop";
import About from "@/components/About";
import Lookbook from "@/components/Lookbook";
import Footer from "@/components/Footer";

function App() {
  const [entered, setEntered] = useState(false);
  const [direction, setDirection] = useState(null);
  const [spun] = useState(() => localStorage.getItem("ms_spun") !== null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [reward, setReward] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!entered) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [entered]);

  const copyCode = () => {
    if (!reward) return;
    navigator.clipboard?.writeText(reward.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen bg-cream text-ink">
      <AnimatePresence>
        {!entered && (
          <Intro
            key="intro"
            spun={spun}
            onComplete={(dir) => {
              localStorage.setItem("ms_spun", dir);
              axios
                .post(`${process.env.REACT_APP_BACKEND_URL}/api/spins`, { direction: dir })
                .catch(() => {});
              setDirection(dir);
              setEntered(true);
            }}
          />
        )}
      </AnimatePresence>

      {entered && (
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.1, ease: "easeOut" }}
        >
          <Hero onCheckout={() => setPopupOpen(true)} />
          <Marquee />
          <StatsStrip />
          <Shop />
          <About />
          <Lookbook />
          <Footer />

          <DiscountPopup
            open={popupOpen}
            direction={direction}
            onClose={() => setPopupOpen(false)}
            onUnlocked={(r) => setReward(r)}
          />

          {reward && !popupOpen && (
            <motion.button
              data-testid="reward-pill"
              onClick={copyCode}
              initial={{ y: 80, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4, type: "spring", stiffness: 120 }}
              className="fixed bottom-6 left-6 z-40 flex items-center gap-3 border border-ink/15 bg-ink px-5 py-3 font-mono text-[11px] tracking-[0.25em] text-cream shadow-2xl transition-colors hover:bg-blush"
            >
              <span className="text-cream/60">{reward.percent}% OFF</span>
              <span data-testid="reward-pill-code">{reward.code}</span>
              <span className="text-cream/50">{copied ? "COPIED" : "TAP TO COPY"}</span>
            </motion.button>
          )}
        </motion.main>
      )}
    </div>
  );
}

export default App;
